import i18n from '@/lang'
//IDM路由，外部地址

const idmRouter = [{
		path: "/extra/idm/password/:type",
		name: "changePwd",
		component: () => import("@/views/idm/password"),
		hidden: true,
		meta: {
			title: i18n.t('common.changePwd')
		}
	},
	{
		path: "/extra/idm/account/:type",
		name: "account",
		component: () => import("@/views/idm/account"),
		hidden: true,
		meta: {
			title: i18n.t('common.account')
		}
	},
	{
		path: "/extra/idm/approval/:type",
		name: "approval",
		component: () => import("@/views/idm/approval"),
		hidden: true,
		meta: {
			title: i18n.t('common.approval')
		}
	},
	{
		path: "/extra/idm/approval/detail/:data",
		name: "approvalDetail",
		component: () => import("@/views/idm/approvaldetail"),
		hidden: true,
		meta: {
			title: i18n.t('common.approvalDetail')
		}
	},
	{
		path: "/extra/idm/approval/delegate/:data",
		name: "approvalDelegate",
		component: () => import("@/views/idm/approvaldelegate"),
		hidden: true,
		meta: {
			title: i18n.t('common.approvalDelegate')
		}
	},
	{
		path: "/extra/idm/request/:type",
		name: "request",
		component: () => import("@/views/idm/requestaccess"),
		hidden: true,
		meta: {
			title: i18n.t('common.request')
		}
	},
	{
		path: "/extra/idm/request/select/access/:data",
		name: "selectAccess",
		component: () => import("@/views/idm/selectaccess"),
		hidden: true,
		meta: {
			title: i18n.t('common.selectAccess')
		}
	},
	{
		path: "/extra/idm/request/select/person/:type",
		name: "selectPerson",
		component: () => import("@/views/idm/selectperson"),
		hidden: true,
		meta: {
			title: i18n.t('common.selectPerson')
		}
	},
	{
		path: "/extra/idm/request/records/:type",
		name: "records",
		component: () => import("@/views/idm/requestrecords"),
		hidden: true,
		meta: {
			title: i18n.t('common.records')
		}
	},
	{
		path: "/extra/idm/request/record/detail/:data",
		name: "recordDetail",
		component: () => import("@/views/idm/recorddetail"),
		hidden: true,
		meta: {
			title: i18n.t('common.recordDetail')
		}
	},
	{
		path: "/extra/idm/person/:type",
		name: "idmPerson",
		component: () => import("@/views/idm/person"),
		hidden: true,
		meta: {
			title: i18n.t('common.idmPerson')
		}
	},
	{
		path: "/extra/idm/access/:type",
		name: "myAccess",
		component: () => import("@/views/idm/access"),
		hidden: true,
		meta: {
			title: i18n.t('common.myAccess')
		}
	},
	{
		path: "/extra/idm/home/:type",
		name: "idmHome",
		component: () => import("@/views/idm/homepage"),
		hidden: true,
		meta: {
			title: i18n.t('common.idmHome')
		}
	}
];

export default idmRouter;
